iScreenWizard.controller('CertificaatController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, Certificaat, userService) {

    $scope.certificates = [];
    $scope.userService = userService;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    var refresh = function() {
        Certificaat.all({behaald: true}).then(function (certificates) {
            $scope.certificates = certificates;
        });
    };
    $scope.refresh = refresh;

    $scope.viewCertificate = function(certificate, ev) {
        $mdDialog.show({
            controller: CertificaatDialogController,
            locals: {
                certificate: certificate
            },
            templateUrl: '/mijn-iscreen/certificaten/show',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        });
    };

    function CertificaatDialogController($scope, certificate) {
        $scope.certificate = certificate;
    };

});